module.exports = __webpack_public_path__ + "img/testimonial-dva.667bc9f7.png";